import { Stack, Typography, Box } from "@mui/material";

interface PaymentPlansTableProps {
  installments: {
    dueDate: string;
    amount: number;
  }[];
  applyTopMargin?: boolean;
}

export function PaymentPlansTable({
  installments,
  applyTopMargin,
}: PaymentPlansTableProps) {
  return (
    <Stack
      direction={"column"}
      sx={{
        borderRadius: "8px",
        mt: applyTopMargin ? 2 : 0,
      }}
    >
      {installments.map((row, idx) => {
        const firstIndex = idx == 0;
        const fontWeight = firstIndex ? 700 : "inherit";
        const lastIndex = idx !== installments.length - 1;
        return (
          <Box key={row.dueDate}>
            <Stack
              direction="row"
              spacing={0.5}
              mt={0.5}
              mb={lastIndex ? 0.5 : 0}
              alignItems="center"
            >
              <Typography
                color="primary.main"
                variant="body1"
                fontWeight={fontWeight}
              >
                {" "}
                •{" "}
              </Typography>
              <Typography variant="body2" fontWeight={fontWeight}>
                ${row.amount.toFixed(2)}
              </Typography>
              <Typography variant="body2" fontWeight={fontWeight}>
                due
              </Typography>
              <Typography variant="body2" fontWeight={fontWeight}>
                {firstIndex ? "today" : row.dueDate}
              </Typography>
            </Stack>

            {lastIndex ? (
              <Box
                ml={0.4}
                height="10px"
                borderLeft="1px dotted"
                borderColor={"primary.main"}
              />
            ) : null}
          </Box>
        );
      })}
    </Stack>
  );
}
